import { NgModule } from '@angular/core';
import { SharedModule } from 'app/shared/shared.module';
import { LoginComponent } from './login.component';
import { ForgotPasswordComponent } from './forgot-password.component';

export const routes = [
    {
        path     : 'login',
        component: LoginComponent
    },
    {
        path     : 'auth/forgot-password',
        component: ForgotPasswordComponent
    }
];

@NgModule({
    declarations: [
        LoginComponent,
        ForgotPasswordComponent
    ],
    imports     : [
        SharedModule
    ]
})
export class LoginModule
{
}
